import en from './catalog/en.json';
import el from './catalog/el.json';

/**
 * Every language the game speaks. Adding one is an entry here and a catalog
 * beside it — see ./README.md.
 *
 * `name` is the language's own name for itself. A switcher offering "Greek"
 * is no use to somebody who cannot read English, which is the only reason
 * they would be opening it.
 */
export const LOCALES = [
  { code: 'en', name: 'English', catalog: en },
  { code: 'el', name: 'Ελληνικά', catalog: el },
];

export const DEFAULT_LOCALE = 'en';

// Beside robotrons:layout — both are per-device display preferences.
export const LOCALE_KEY = 'robotrons:locale';

export const catalogFor = code =>
  LOCALES.find(l => l.code === code)?.catalog;

const known = code => LOCALES.some(l => l.code === code);

/**
 * Which language to open in.
 *
 * A stored choice always wins: it is the only signal that came from the
 * player rather than from their operating system. Browser languages are
 * matched on the primary subtag, so `el-GR` and `el-CY` both find Greek.
 *
 * @param {?string} stored              localStorage value, if any.
 * @param {string[]} navigatorLanguages `navigator.languages`, most-preferred first.
 *
 * @return {string} A registered locale code.
 */
export function resolveInitialLocale(stored, navigatorLanguages = []) {
  if (stored && known(stored)) return stored;

  for (const tag of navigatorLanguages) {
    const primary = String(tag).split('-')[0].toLowerCase();
    if (known(primary)) return primary;
  }

  return DEFAULT_LOCALE;
}
